import { Category } from '@modules/common/types';
import { SentimentName } from 'v2/core/entities/fields';
import { TextMatchedFeedback } from 'v2/core/entities/labels';

export const getOptimisticEntityUnits = (
  category: Category,
): TextMatchedFeedback[] => {
  return [
    {
      type: 'TEXT',
      startIDx: 0,
      endIDx: 0,
      category: category,
      sentiment: SentimentName.NEUTRAL,
    },
  ];
};
